import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.define-property";
import _pick from "lodash/pick";
import _get from "lodash/get";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Impression } from '@nerdwallet/analytics/react/impression';
import * as actions from '../redux/actions';
import CompareCTA from './compare-cta';
import './compare-card-sticky.less';
/**
 * The compare card sticky renders the compare card CTA seen across the bottom of the credit cards
 * tool. This is the experimental version with slightly different layout, a lighter background,
 * and supports an animation when a user adds a card to the compare list.
 *
 * Shows a count of cards to compare with cta to navigate to the comparison
 * page or clear their comparisons. On the comparison page, provides an option to navigate back to
 * the page they came from. This is the Component that gets exported.
 *
 * @class
 */

export var CompareCardSticky =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareCardSticky, _React$Component);

  var _super = _createSuper2(CompareCardSticky);

  function CompareCardSticky() {
    _classCallCheck(this, CompareCardSticky);

    return _super.apply(this, arguments);
  }

  _createClass(CompareCardSticky, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      // So the sticky bar does not cover footer text when the user scrolls all the way down
      if (this.isStickyActive()) {
        document.querySelector('body').style.paddingBottom = '60px';
      } else {
        document.querySelector('body').style.paddingBottom = '0';
      }
    }
  }, {
    key: "isStickyActive",
    value: function isStickyActive() {
      return this.props.isCompareCardsBusy || this.props.forceActive || this.props.compareCards.cardIDsToCompare.length;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$analytics, _this$props$analytics2, _this$props$analytics3;

      var active = this.isStickyActive();
      var stickyClasses = classNames('compare-sticky', {
        active: active,
        'with-card-images': this.props.showCardImages
      });
      var numCardsToCompare = _get(this.props, 'compareCards.cardIDsToCompare.length') || 0;
      return React.createElement("div", {
        className: stickyClasses
      }, active ? React.createElement(Impression, {
        entityName: "cc_compare_cards_banner",
        enabled: (_this$props$analytics = this.props.analytics) === null || _this$props$analytics === void 0 ? void 0 : _this$props$analytics.enabled,
        payload: {
          section_name: (_this$props$analytics2 = this.props.analytics) === null || _this$props$analytics2 === void 0 ? void 0 : (_this$props$analytics3 = _this$props$analytics2.payload) === null || _this$props$analytics3 === void 0 ? void 0 : _this$props$analytics3.sectionName
        }
      }, React.createElement("div", {
        className: "sticky-content"
      }, React.createElement(CompareCTA, {
        isCompareCardsBusy: this.props.isCompareCardsBusy,
        numCardsToCompare: numCardsToCompare,
        clearCompareList: this.props.clearCompareList,
        removeFromCompare: this.props.removeFromCompare,
        saveToCompare: this.props.saveToCompare,
        showBackButton: this.props.showBackButton,
        history: this.props.history,
        buttonClassName: "ripply bubbly",
        isLinkToSameApp: this.props.isLinkToSameApp,
        overrideCTA: this.props.overrideCTA,
        ctaText: this.props.ctaText,
        disableReset: this.props.disableReset,
        showCardImages: this.props.showCardImages,
        showAddCard: this.props.showAddCard,
        cardsToCompare: this.props.compareCards.cardsToCompare,
        offerSDK: this.props.offerSDK,
        marketplaceSDK: this.props.marketplaceSDK,
        cardIDsToCompare: _get(this.props, 'compareCards.cardIDsToCompare'),
        taxonomy: this.props.taxonomy,
        analytics: this.props.analytics
      }))) : null);
    }
  }]);

  return CompareCardSticky;
}(React.Component);

_defineProperty(CompareCardSticky, "propTypes", {
  clearCompareList: PropTypes.func,
  compareCards: PropTypes.shape({
    cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
    cardsToCompare: PropTypes.object
  }),
  ctaText: PropTypes.objectOf(PropTypes.string),
  disableReset: PropTypes.bool,
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  forceActive: PropTypes.bool,
  history: PropTypes.shape({
    goBack: PropTypes.func // eslint-disable-line react/no-unused-prop-types

  }),
  isCompareCardsBusy: PropTypes.bool,
  isLinkToSameApp: PropTypes.bool,
  offerSDK: PropTypes.shape({}).isRequired,
  overrideCTA: PropTypes.node,
  removeFromCompare: PropTypes.func,
  saveToCompare: PropTypes.func,
  marketplaceSDK: PropTypes.shape({}).isRequired,
  showAddCard: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showCardImages: PropTypes.bool,
  taxonomy: PropTypes.shape({})
});

_defineProperty(CompareCardSticky, "defaultProps", {
  isLinkToSameApp: false,
  compareCards: {
    cardIDsToCompare: [],
    cardsToCompare: {}
  },
  analytics: {
    enabled: false
  },
  showCardImages: false,
  showAddCard: false,
  taxonomy: {}
});

var mapStateToProps = function mapStateToProps(state) {
  var mappedState = _pick(state, ['compareCards', 'ctaText', 'disableReset', 'experiments', 'forceActive', 'history', 'isLinkToSameApp', 'overrideCTA', 'showAddCard', 'showBackButton', 'showCardImages']);

  mappedState.isCompareCardsBusy = _get(state, 'compareCards.isCompareCardsBusy');
  return mappedState;
};

var mapDispatchToProps = {
  clearCompareList: actions.clearCompareList,
  removeFromCompare: actions.removeFromCompare,
  saveToCompare: actions.saveToCompare
};
/**
 * We connect to our own removeFromCompare action. But in cc-client, we want to be able to override
 * it with a wrapper that causes the compare-cards page to be updated.
 *
 * @function
 * @param {Object} stateProps - props as provided by mapStateToProps.
 * @param {Object} dispatchProps - props as provided by mapDispatchToProps
 * @param {Object} ownProps - props as provided by the parent element.
 * @returns {Object} - a merged prop with ownProps taking precedence over dispatchProps and
 *                     stateProps (in that order).
 */

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _objectSpread2(_objectSpread2(_objectSpread2({}, stateProps), dispatchProps), ownProps);
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompareCardSticky);
//# sourceMappingURL=compare-card-sticky.js.map